import React from 'react'
import { Snackbar, makeStyles } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { fontClasses } from '../../fontStyles';
import { isiOS ,isWeb } from "../../utils/utility";
import Icon from "../../utils/icons";


const useStyles = makeStyles(theme => ({
  errorRoot: {
    minHeight: "50px",
    width: '100%',
    backgroundColor: `${theme.palette.primary.errorToastBackground} !important`,
    color: theme.palette.primary.AlertMsgColor,
    '&.MuiPaper-root': {
      color: '#fff !important',
      padding : isWeb() ? '15px':0,
      '& .MuiAlert-message': {
      padding:  isWeb() ? '8px 0':0,
      },
    },
    
  },
   isPermissionDeniedMsg: {
      '&.MuiPaper-root': {
        backgroundColor: '#ff5959',
        padding : isWeb() ? '12px 15px':'15px 0 15px !important',
        '& .MuiAlert-message': {
          padding:  isWeb() ? 0:'0 15px 0 0',
          lineHeight: '16px'
        },
      }
     },
  alertRoot: {
    minHeight: "50px",
    borderRadius: '0px',
    width: '100%',
    backgroundColor: theme.palette.primary.toastBackground,
    color: theme.palette.primary.AlertMsgColor,
    '&.MuiPaper-root': {
      color: '#fff !important',
      padding : 0,
      '& .MuiAlert-message': {
      padding:  0,
    },
    },
    '&.MuiAlert-filledError': {
      color: '#fff !important',
    },
  },
  successRoot: {
    minHeight: "50px",
    borderRadius: '0px',
    width: '100%',
    backgroundColor: '#5cd482 !important',
    color: theme.palette.primary.AlertMsgColor,
    '&.MuiPaper-root': {
      color: '#fff !important',
      padding : isWeb() ? '15px':0,
      '& .MuiAlert-message': {
      padding:  isWeb() ? '8px 0':0,
    },
    },
    '&.MuiAlert-filledError': {
      color: '#fff !important',
    },
  },
  mobileWrapper: {
    width: '100% !important',
    left: '0 !important',
    right: '0 !important',
    transform: 'none !important',
    bottom : 'unset',
    top: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',

    '& .MuiAlert-root': {
      borderRadius: '0px',
      padding: 0,
      alignItems: 'center'
    },
    '& .MuiAlert-icon' : {
      padding : '5px 0px',
      margin : '0px 10px 0px 15px',
      '& svg':{
        width:'20px',
        height:'20px'
      }
    },
    '& .MuiAlert-message' : {
      display : 'flex',
      alignItems : 'center',
      gap : '80px !important',
      fontSize: '14px',
      fontFamily: 'Visuelt',
      fontWeight:300,
      lineHeight:'16px',
      padding: '15px 15px 15px 0'
    },
  },
  fullWidthWebWrapper: {
    width: '100%',
    left: '0 !important',
    right: '0 !important',
    bottom: 'unset',
    top: '64px',
    '& .MuiAlert-root': {
      borderRadius: '0px',
      padding: 0,
      alignItems: 'center'
    },
    '& .MuiAlert-icon' : {
      padding : '5px 0px',
      margin : '0px 10px 0px 15px',
      '& svg':{
        width:'20px',
        height:'20px'
      }
    },
    '& .MuiAlert-message' : {
      display : 'flex',
      alignItems : 'center',
      fontSize: '14px',
      fontFamily: 'Visuelt',
      fontWeight:300,
      lineHeight:'16px',
      padding: '15px 15px 15px 0'
    },
  },
  browserWrapper: {
    width: '450px',
    top:'13%',
    bottom : 'unset !important',
    '& .MuiAlert-root': {
      borderRadius: '0px',
      '& .MuiAlert-icon' : {
      padding : '5px 0px',
      '& svg':{
        width:'24px',
        height:'24px'
      }
    },
    },
    
    '& .MuiAlert-message' : {
      fontSize: '15px',
      padding:0
     },
    '& .MuiAlert-icon' : {
      alignItems : 'center',
    },
  },
  scheduleToast:{
    top:'12%',
    '& .MuiAlert-message':{
      padding:'0 10px'
    }
  },
  bottomToast:{
    bottom : '9% !important', 
    '& .MuiAlert-message' : {
      flex: 0.94,
      justifyContent: 'space-between'
    }
  },
  msg: {
    ...fontClasses.fontSecondary,
  },
}));

function ToastMessage({ shouldDisplay, type, content, handleClose, isSmartScheduleToast = false, bottomPosition = false,isPermissionDeniedMsg=false, fullWidth=false}) {
  const classes = useStyles()
  const duration = 5000;
  const toastType = type === 'success' ? classes.successRoot : (type === 'error') ? isPermissionDeniedMsg ?classes.isPermissionDeniedMsg :classes.errorRoot : classes.alertRoot;
  const toastIcon = type === 'success' ? <Icon src='TickWhiteSmall'/> : <Icon src='caution'/>
  const handleClick = () => {
    setTimeout(() => {
      handleClose();
    }, duration);
  }

  return (
    <Snackbar
      open={shouldDisplay}
      autoHideDuration={duration}
      classes={{ root: isWeb() ? `${classes.browserWrapper}  ${isSmartScheduleToast ? classes.scheduleToast : ''} ${bottomPosition ? classes.bottomToast : ''} ${isPermissionDeniedMsg ? classes.isPermissionDeniedMsg : ''}` : `${classes.mobileWrapper}  ${isSmartScheduleToast ? classes.scheduleToast : ''} ${bottomPosition ? classes.bottomToast : ''} ${isPermissionDeniedMsg ? classes.isPermissionDeniedMsg : ''}` }}
      style={{ zIndex: 10002 }}
      onClose={(event, reason) => { if (reason !== 'clickaway') handleClose(); }}
      onClick={handleClick}
      data-testid="toast-meassage"
    >
      <MuiAlert severity="error" icon={toastIcon} variant="filled" classes={{ root: toastType, message: classes.msg }}>
        {content}
      </MuiAlert>
    </Snackbar>
  )
}

ToastMessage.defaultProps = {
  shouldDisplay: false,
  content: '',
  type: 'error',
  handleClose: null
}

export default ToastMessage;